import React, {Component} from 'react';
import { Card,Button,Input,List,Modal} from 'antd';
import StuffCard from "./stuffCard";
import { Scrollbars } from 'react-custom-scrollbars';
import {HEADER_HEIGHT} from "../constants";
import {uuid} from "../utils";
import {getExaminedList, getMaterialList, getTodoListList} from "../actions/weiChat";
import EditMaterial from "./editMaterial";
import BaseComponent from "../base/BaseComponent";

const { Search } = Input;
const tabList = [
    {
        key: 'all',
        tab: '全部',
    },
    {
        key: 'approved',
        tab: '已审核',
    },
    {
        key: 'published',
        tab: '已发布',
    },
    {
        key: 'abandoned',
        tab: '已弃用',
    },
    {
        key: 'needHandle',
        tab: '待我处理',
    }
];

class WeiChatPublish extends BaseComponent {

    // 记录每个tab页当前页码
    defaultParams = {
        mediaId: this.props && this.props.match && this.props.match.params && this.props.match.params.currentMedia ? this.props.match.params.currentMedia : 0,
        allStart: 1,
        needHandleStart:0,
        approvedStart:1,
        publishedStart:1,
        abandonedStart:1,
        queryStr: ""
    };

    params = Object.assign({},this.defaultParams);

    default = {
        start : 1,
        size : 10
    };

    state = {
        loading: true,
        key: 'all',
        allData:[],
        needHandleData: [],
        approvedData: [],
        publishedData: [],
        abandonedData: [],
        editModalVisible: false,
        editModalTitle : "",
        editModalMaterialId : 0
    };

    componentDidMount() {
        this.initData(this.state.key,true);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.defaultParams.mediaId = nextProps.match.params.currentMedia;
        this.params = Object.assign({},this.defaultParams);
        this.initData(this.state.key,true);
    }

    initData = (currentTab, clear)=>{
        let win = window.top || window;
        let index = win.layer.load();
        if(!this.params.mediaId){
            win.layer.close(index);
            return
        }
        if(currentTab === 'all'){
            let params ={
                tabType: currentTab,
                start: (()=>{
                    if(clear){
                        this.params.allStart = this.defaultParams.allStart;
                    }
                    return this.params.allStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                queryStr: this.params.queryStr
            };
            getMaterialList(params,(res)=>{
                this.setState(prevState=>{
                    if(clear){
                        prevState.allData = [];
                    }
                    this.reloadAllDataCache(res.data);
                    prevState.allData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            })
        }else if(currentTab === 'needHandle'){
            let params ={
                deploymentKey : "weixin",
                page: (()=>{
                    if(clear){
                        this.params.needHandleStart = this.defaultParams.needHandleStart;
                    }
                    return this.params.needHandleStart
                })(),
                size: this.default.size,
                query: {
                    mediaId: this.params.mediaId
                }
            };
            getTodoListList(params,(res)=>{
                this.setState(prevState=>{
                    if(clear){
                        prevState.needHandleData = [];
                    }
                    this.reloadAllDataCache(res);
                    prevState.needHandleData.push(...res);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            });
        }else if(currentTab === 'approved'){
            let params ={
                deploymentKey : "weixin",
                page: (()=>{
                    if(clear){
                        this.params.approvedStart = this.defaultParams.approvedStart;
                    }
                    return this.params.approvedStart
                })(),
                size: this.default.size,
                query: {
                    mediaId: this.params.mediaId
                }
            };
            getExaminedList(params,(res) =>{
                this.setState(prevState=>{
                    if(clear){
                        prevState.approvedData = [];
                    }
                    this.reloadAllDataCache(res.data);
                    prevState.approvedData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            });
        }else if(currentTab === 'published'){
            let params ={
                tabType: currentTab,
                start: (()=>{
                    if(clear){
                        this.params.publishedStart = this.defaultParams.publishedStart;
                    }
                    return this.params.publishedStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                queryStr: this.params.queryStr
            };
            getMaterialList(params,(res)=>{
                this.setState(prevState=>{
                    if(clear){
                        prevState.publishedData = [];
                    }
                    this.reloadAllDataCache(res.data);
                    prevState.publishedData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            })
        }else if(currentTab === 'abandoned'){
            let params ={
                tabType: currentTab,
                start: (()=>{
                    if(clear){
                        this.params.abandonedStart = this.defaultParams.abandonedStart;
                    }
                    return this.params.abandonedStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                queryStr: this.params.queryStr
            };
            getMaterialList(params, (res)=>{
                this.setState(prevState=>{
                    if(clear){
                        prevState.abandonedData = [];
                    }
                    this.reloadAllDataCache(res.data);
                    prevState.abandonedData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            })
        }

    };

    allDataCache;

    reloadAllDataCache = (data) => {
        let addToCacheList = [];
        let fromCacheRemove = [];
        data.map(material=>{
            let isAddToCache = true;
            this.allDataCache.map(cache=>{
                if(material.id === cache.id){
                    material.uuid = cache.uuid?cache.uuid:uuid();
                    let oldStuffList = cache.stuffList;
                    let newCache = Object.assign(cache, material);//这个里面stuffList的stuff没有uuid
                    fromCacheRemove.push(cache);
                    addToCacheList.push(newCache);
                    //cache 这个里面stuffList的stuff有uuid
                    for(let i = 0 ; newCache.stuffList && i < newCache.stuffList.length; i++){
                        let newStuff = newCache.stuffList[i];
                        let _uuid = uuid();
                        for(let j = 0 ; oldStuffList && j < oldStuffList.length; j++){
                            let oldStuff = oldStuffList[j];
                            if(oldStuff.id === newStuff.id){
                                _uuid = oldStuff.uuid?oldStuff.uuid:_uuid;
                                break;
                            }
                        }
                        newStuff.uuid = _uuid;
                    }
                    isAddToCache = false;
                    material.stuffList = newCache.stuffList;
                }
            });
            if(isAddToCache){
                addToCacheList.push(material);
            }
        });
        this.allDataCache = this.allDataCache.filter(cache=>{
            let remove = false;
            fromCacheRemove.map(item=>{
                if(cache.id===item.id)remove=true;
            });
            return !remove;
        });
        this.allDataCache.push(...addToCacheList);
    };

    reloadMaterialList = () =>{
        let currentTab = this.state.key;
        if(currentTab === 'all'){
            this.params.allStart = 1;
        }else if(currentTab === 'needHandle'){
            this.params.needHandleStart = 0;
        }else if(currentTab === 'approved'){
            this.params.approvedStart = 0;
        }else if(currentTab === 'published'){
            this.params.publishedStart = 1;
        }else if(currentTab === 'abandoned'){
            this.params.abandonedStart = 1;
        }
        this.initData(currentTab,true);
    };

    onTabChange = (key, type) =>{
        this.setState({ [type]: key });
        this.initData(key, true);
    };

    /*监听滚动*/
    onScroll = e => {
        if(e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            // 滚动到底部需要做的事情
            let currentTab = this.state.key;
            if(currentTab === 'all'){
                this.params.allStart ++;
            }else if(currentTab === 'needHandle'){
                this.params.needHandleStart ++;
            }else if(currentTab === 'approved'){
                this.params.approvedStart ++;
            }else if(currentTab === 'published'){
                this.params.publishedStart ++;
            }else if(currentTab === 'abandoned'){
                this.params.abandonedStart ++;
            }
            this.initData(currentTab,false);
        }
    };
    //消息群发
    publish=()=>{
        let win = window.top || window;
        let index = win.layer.load();
        this.request({
            url:'/cm-sites-pms/material/publish',
            method:'post',
            contentType:'json',
            callBack:(res)=>{
                console.log(res);
                this.setState(prevState=>{
                    this.reloadAllDataCache(res.data);
                    prevState.publishedData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                win.layer.close(index)
            }
        })
    };
    search = value =>{
        this.params.queryStr = value;
        let currentTab = this.state.key;
        if(currentTab === 'all'){
            this.params.allStart  = 1;
            this.setState({
                allData: []
            });
        }else if(currentTab === 'needHandle'){
            this.params.needHandleStart = 1;
            this.setState({
                needHandleData: []
            });
        }else if(currentTab === 'approved'){
            this.params.approvedStart = 1;
            this.setState({
                approvedData: []
            });
        }else if(currentTab === 'published'){
            this.params.publishedStart = 1;
            this.setState({
                publishedData: []
            });
        }else if(currentTab === 'abandoned'){
            this.params.abandonedStart = 1;
            this.setState({
                abandonedData: []
            });
        }
        this.initData(currentTab,true);
    };

    editMaterial = (materialId) => {
        let title = materialId > 0 ? "编辑素材" : "新增素材";
        this.setState({
            editModalVisible : true,
            editModalTitle : title,
            editModalMaterialId : materialId || 0
        })
    };

    /**
     * 隐藏素材编辑框
     * @param reload   是否需要刷新素材列表
     */
    updateEditModalVisible = (reload) =>{
        this.setState({
            editModalVisible : false
        });
        if(reload){
           this.reloadMaterialList();
        }
    };

    render() {
        let border = 1;
        let cardMargin = 15;
        let cardPadding = 24;
        let h = parseInt(HEADER_HEIGHT) + cardMargin * 2 + 103 + cardPadding * 2 + border * 2;
        let height = "calc(100vh - "+ h +"px)";
        let width = "100%";
        let currentTab = this.state.key;
        let currentData;
        if(currentTab === 'all'){
            currentData = this.state.allData;
        }else if(currentTab === 'needHandle'){
            currentData = this.state.needHandleData;
        }else if(currentTab === 'approved'){
            currentData = this.state.approvedData;
        }else if(currentTab === 'published'){
            currentData = this.state.publishedData;
        }else if(currentTab === 'abandoned'){
            currentData = this.state.abandonedData;
        }
        console.log("currentData====", currentData);
        this.allDataCache = currentData;
        let content = <Scrollbars
            onScroll={this.onScroll.bind(this)}
            autoHide
            autoHideTimeout={1}
            autoHideDuration={1}
            style={{height,width}}>
            <List
                style={{overflowX:"hidden"}}
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 3,
                    xxl: 4,
                }}
                loading={this.state.loading}
                dataSource={currentData}
                renderItem={item => {
                    item.uuid = item.uuid?item.uuid:uuid();
                    return ( <List.Item>
                            <StuffCard key={item.uuid} {...item} editMaterial={this.editMaterial.bind(this)} reloadMaterialList={this.reloadMaterialList.bind(this)}/>
                        </List.Item>)
                }}
            />
        </Scrollbars>;

        let {editModalVisible, editModalTitle,editModalMaterialId} = this.state;
        return (
            <div style={{marginBottom:'10px'}}>
                <Card
                    style={{ margin:15 }}
                    // title={<Button type="primary" onClick={() =>this.editMaterial(0)}>新增素材</Button>}
                    extra={<Search placeholder="" onSearch={value => this.search(value)} enterButton />}
                    tabList={tabList}
                    activeTabKey={this.state.key}
                    onTabChange={key => {
                        this.onTabChange(key, 'key');
                    }}
                   
                >
                    {content}
                </Card>
                <MaterialModel visible={editModalVisible} title={editModalTitle} mediaId={this.params.mediaId} materialId={editModalMaterialId}
                               updateVisible={this.updateEditModalVisible.bind(this)}
                />
            </div>
        );
    }
}

export class MaterialModel extends Component{
    constructor(props){
        super(props);
        this.state = {
            title : props.title,
            materialId : props.materialId || 0,
            mediaId : props.mediaId,
            visible : props.visible
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            title : nextProps.title,
            materialId : nextProps.materialId || 0,
            mediaId : nextProps.mediaId,
            visible : nextProps.visible
        });
        this.updateVisible = nextProps.updateVisible;
    }

    updateVisible = ()=>{};

    onCancel = (reload) => {
        if(this.updateVisible){
            this.updateVisible(reload);
        }else {
            this.setState({
                visible : false
            })
        }

    };

    render() {
        let {title,visible, mediaId, materialId} = this.state;
        return <Modal
            title={title}
            visible={visible}
            footer={null}
            width={'60%'}
            centered={true}
            maskClosable={false}
            onCancel={() =>this.onCancel(false)}
            bodyStyle={{padding:0,overflowX:"hidden"}}
        >
            <EditMaterial onAdvance={() => this.onCancel(true)} key={uuid()} mediaId={mediaId} materialId={materialId}/>
        </Modal>
    }
}

export default WeiChatPublish;